import { IntRange } from 'src/typings/numbers'
import { Color } from './Colors'

export enum SimulationStatus {
  NEW = 'NEW',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  PREPROCESSING = 'PREPROCESSING',
  GENERATING_INPUTS = 'GENERATING_INPUTS',
  SIMULATING = 'SIMULATING',
  POSTPROCESSING = 'POSTPROCESSING',
  ERROR_REPORT = 'ERROR_REPORT',
  ERROR_IGP = 'ERROR_IGP',
  ERROR_REPORT_IGP = 'ERROR_REPORT_IGP'
}

export namespace SimulationStatus {
  export function getProgress(
    status: SimulationStatus
  ): IntRange<0, 101> | undefined {
    switch (status) {
      case SimulationStatus.NEW:
        return 0
      case SimulationStatus.COMPLETED:
        return 100
      case SimulationStatus.PREPROCESSING:
        return 10
      case SimulationStatus.GENERATING_INPUTS:
        return 30
      case SimulationStatus.SIMULATING:
        return 70
      case SimulationStatus.POSTPROCESSING:
        return 100
    }
  }

  export function getTextKey(status: SimulationStatus): string | undefined {
    switch (status) {
      case SimulationStatus.NEW:
      case SimulationStatus.PREPROCESSING:
      case SimulationStatus.GENERATING_INPUTS:
      case SimulationStatus.SIMULATING:
      case SimulationStatus.POSTPROCESSING:
        return 'processing'
      case SimulationStatus.ERROR:
        return 'simulationErrorTryAgain'
      case SimulationStatus.ERROR_REPORT:
        return 'simulationErrorGenerateReport'
      case SimulationStatus.ERROR_IGP:
        return 'simulationErrorGenerateIGP'
      case SimulationStatus.ERROR_REPORT_IGP:
        return 'simulationErrorGenerateReport'
    }
  }

  export function getIcon(status: SimulationStatus): string | undefined {
    switch (status) {
      case SimulationStatus.NEW:
      case SimulationStatus.PREPROCESSING:
      case SimulationStatus.GENERATING_INPUTS:
      case SimulationStatus.SIMULATING:
      case SimulationStatus.POSTPROCESSING:
        return 'pi-info-circle'
      case SimulationStatus.COMPLETED:
        return 'pi-verified'
      case SimulationStatus.ERROR:
        return 'pi-times-circle'
      case SimulationStatus.ERROR_REPORT:
        return 'pi-exclamation-triangle'
      case SimulationStatus.ERROR_IGP:
        return 'pi-exclamation-triangle'
      case SimulationStatus.ERROR_REPORT_IGP:
        return 'pi-exclamation-triangle'
    }
  }

  export function getColor(status: SimulationStatus): Color {
    switch (status) {
      case SimulationStatus.NEW:
        return Color.SIMULATION_LOADING
      case SimulationStatus.COMPLETED:
        return Color.SIMULATION_LOADING
      case SimulationStatus.ERROR:
        return Color.SIMULATION_ERROR
      case SimulationStatus.PREPROCESSING:
      case SimulationStatus.GENERATING_INPUTS:
      case SimulationStatus.SIMULATING:
      case SimulationStatus.POSTPROCESSING:
        return Color.SIMULATION_LOADING
      case SimulationStatus.ERROR_REPORT:
        return Color.SIMULATION_DARK_GRAY
      case SimulationStatus.ERROR_IGP:
        return Color.SIMULATION_DARK_GRAY
      case SimulationStatus.ERROR_REPORT_IGP:
        return Color.SIMULATION_DARK_GRAY
      default:
        return Color.SIMULATION_LOADING
    }
  }
}
